import { render } from "./ProductoView.vue?vue&type=template&id=60eebcab&scoped=true"
import script from "./ProductoView.vue?vue&type=script&lang=js"
export * from "./ProductoView.vue?vue&type=script&lang=js"

import "./ProductoView.vue?vue&type=style&index=0&id=60eebcab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60eebcab"]])

export default __exports__